import * as _ from 'lodash';
import { Guid } from '../../helpers/guid.helper';
import { CuttingButt } from './cutting-butt.model';
import { CuttingFacadeOutline } from './cutting-facade-outline.model';

export class CuttingFacade {
  textureDirection: FacadeTextureDirectionEnum = FacadeTextureDirectionEnum.AlongWidth;
  uuid: string = Guid.newGuid();
  position: string;
  name: string;
  remark: string;
  height: number;
  width: number;
  orientation: boolean;
  count: number;
  panelOutline: CuttingFacadeOutline = new CuttingFacadeOutline();
  l1: CuttingButt;
  l2: CuttingButt;
  w1: CuttingButt;
  w2: CuttingButt;

  constructor(pan?: any) {
    pan = pan || {};

    _.merge(this, pan);
  }
}

export enum FacadeTextureDirectionEnum {
  AlongWidth,
  AlongHeight,
}
